import React from 'react'

function MenuClose() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <path
        fill="#FCE531"
        fillRule="evenodd"
        d="M4.497 4.208a1 1 0 0 1 1.415 0L15 13.297l9.088-9.089a1 1 0 0 1 1.415 0l.289.29a1 1 0 0 1 0 1.414L16.703 15l9.089 9.088a1 1 0 0 1 .083 1.32l-.083.095-.29.289a1 1 0 0 1-1.414 0L15 16.703l-9.088 9.089a1 1 0 0 1-1.415 0l-.289-.29a1 1 0 0 1 0-1.414L13.297 15 4.208 5.912a1 1 0 0 1-.083-1.32l.083-.095z"
      />
    </svg>
  )
}

export default MenuClose
